import { CombinedCustomerAuditCategory } from "Hooks/Api/apiCustomerAudits";
import { LocaleCompareObjectAsc } from "Util/StringUtils";
import { ComboboxOption } from "Views/Components/Combobox/Combobox";
import { accountType, accountTypeOptions, atbFileType, customerApplicationStatus, organisationCategory, referrerCommissionFrequencyOptions } from "../Enums";
import { DataTypeSource } from "Models/Enums";


export const customerApplicationStatusComboboxOptions: ComboboxOption<customerApplicationStatus | 'ALL'>[] = [
	{ display: 'All Statuses', value: 'ALL' },
	{ display: 'Pending', value: 'PENDING' },
	{ display: 'Approved', value: 'APPROVED' },
	{ display: 'Referred', value: 'REFERRED' },
	{ display: 'Declined', value: 'DECLINED' },
	{ display: 'Not Started', value: 'NOT_STARTED' },
	{ display: 'Incomplete', value: 'INCOMPLETE' },
];

export const customerApplicationStatusOptions: { [key in customerApplicationStatus]: string } = {
	PENDING: 'Pending',
	APPROVED: 'Approved',
	REFERRED: 'Referred',
	DECLINED: 'Declined',
	NOT_STARTED: 'Not Started',
	INCOMPLETE: 'Incomplete',
	UNKNOWN: 'Unknown',
};

export const organisationAccountTypeComboboxOptions: ComboboxOption<accountType>[] = (
	(Object.keys(accountTypeOptions) as [accountType])
		.map<ComboboxOption<accountType>>(value => {
			return {
				display: accountTypeOptions[value],
				value: value,
			};
		})
);

export const organisationCategoryComboboxOptions: ComboboxOption<organisationCategory>[] = [
	{ display: "Extra Small", value: "PAYG"},
	{ display: "Small", value: "SMALL"},
	{ display: "Medium", value: "MEDIUM"},
	{ display: "Large", value: "LARGE"},
	{ display: "Enterprise", value: "ENTERPRISE"},
];

export const customerAuditCategoryComboboxOptions: ComboboxOption<CombinedCustomerAuditCategory | 'ALL'>[] = [
	{ display: 'All Update Types', value: 'ALL' },
	{ display: 'Account Information', value: 'ACCOUNT_INFORMATION' },
	{ display: 'Adverse Alert', value: 'ADVERSE_ALERT' },
	{ display: 'Business Information', value: 'BUSINESS_INFORMATION' },
	{ display: 'Comment', value: 'COMMENT' },
	{ display: 'Credit Default', value: 'CREDIT_DEFAULT' },
	{ display: 'Entity Update', value: 'ENTITY_UPDATE' },
	{ display: 'Risk Score', value: 'RISK_SCORE' },
	{ display: 'Other', value: 'OTHER' },
];

export const atbFileTypeComboboxOptions: ComboboxOption<atbFileType | 'ALL'>[] = [
	{ display: 'All Types', value: 'ALL' },
	{ display: 'Xero', value: 'XERO'},
	{ display: 'Standard', value: 'STANDARD'},
	{ display: 'Unknown', value: 'UNKNOWN'},
	{ display: 'Customers Only', value: 'CUSTOMERS_ONLY'},
];

export const referrerCommissionFrequencyComboboxOptions = () : ComboboxOption<string>[] => {
	const values = Object.keys(referrerCommissionFrequencyOptions);

	return values
		.sort(LocaleCompareObjectAsc(referrerCommissionFrequencyOptions))
		.map<ComboboxOption<string>>((value, index, array) => {
			return { display: referrerCommissionFrequencyOptions[value], value: value };
		});
};

// Options in alphabetic order
export const referrerBusinessTypeRegistrationComboboxOptions: ComboboxOption<string>[] = [
	{ display: 'Credit bureau', value: 'CREDIT_BUREAU' },
	{ display: 'Credit insurance broker', value: 'CREDIT_INSURANCE_BROKER' },
	{ display: 'Debt collection', value: 'DEBT_COLLECTION' },
	{ display: 'I am an individual', value: 'INDIVIDUAL' },
	{ display: 'Insolvency practitioner', value: 'INSOLVENCY_PRACTITIONER' },
	{ display: 'Lawyer', value: 'LAWYER' },
	{ display: 'Other (provide details)', value: 'OTHER' },
];

export const referrerBenefitTypeRegistrationComboboxOptions: ComboboxOption<string>[] = [
	{ display: 'Client to receive overall discount', value: 'CLIENT_DISCOUNT' },
	{ display: 'Do not receive commission', value: 'NO_COMMISSION' },
	{ display: 'Receive commission', value: 'COMMISSION' },
	{ display: 'Send commission to charity', value: 'CHARITY' },
];

export const dataTypeSourceOptions: { [key in DataTypeSource]: string } = {
	Live: 'Live Data',
	Internal: 'Last Synced',
	Unavailable: 'Unavailable',
};

export const dataTypeSourceIcons: { [key in DataTypeSource]: {
	icon: string,
} } = {
	Live: {
		icon: 'globe',
	},
	Internal: {
		icon: 'wifi-off',
	},
	Unavailable: {
		icon: 'warning-2',
	},
};
